import LoadingSpinner from '@carvana/ds-spinner';
import cx from 'classnames';
import { useContext } from 'react';
import DsModal from '@/common/DsModal';
import Badge from '@/vdp/Hero/Badge';
import Spinner from '@/vdp/Spinner';
import { SectionId } from '~/constants/vdp/section';
import { useIsDesktop } from '~/context/common/DeviceContext';
import SpinnerContext from '~/context/vdp/SpinnerContext';
import { useGetIsWIPVehicle } from '~/context/vdp/VehicleContext';
import useShouldShowMiniHeroDesktop from '~/hooks/vdp/useShouldShowMiniHeroDesktop';
import useShouldShowMiniHeroMobile from '~/hooks/vdp/useShouldShowMiniHeroMobile';
import HeroContent from './HeroContent';
import ImageOverlay from './ImageOverlay';
import SpinnerButtons from './SpinnerButtons';
import UnavailableHeroContent from './UnavailableHeroContent';
import VehicleImage from './VehicleImage';
import {
  CondensedHeroWrapper,
  CondensedImageWrapper,
  CondensedMiniHeroWrapper
} from '../Hero.styles';

export default function Hero() {
  const {
    isSpinnerImmersive,
    setShouldOpenSpinnerArgs,
    shouldOpenSpinnerArgs
  } = useContext(SpinnerContext);
  const isDesktop = useIsDesktop();
  const isWIPVehicle = useGetIsWIPVehicle();
  const shouldShowMiniHeroDesktop = useShouldShowMiniHeroDesktop();
  const shouldShowMiniHeroMobile = useShouldShowMiniHeroMobile();
  const isMiniHero = shouldShowMiniHeroDesktop || shouldShowMiniHeroMobile;

  const imageBlock = (
    <CondensedImageWrapper>
      <ImageOverlay />
      <VehicleImage />
    </CondensedImageWrapper>
  );
  const spinnerButtons = isWIPVehicle ? null : <SpinnerButtons />;
  const Wrapper = isMiniHero ? CondensedMiniHeroWrapper : CondensedHeroWrapper;

  return (
    <div className="sm:col-span-1">
      <Wrapper
        className={cx(SectionId.General, 'relative')}
        data-testid="hero-container"
        id={SectionId.Hero}
      >
        {isMiniHero ? (
          shouldShowMiniHeroDesktop ? (
            <div className="flex items-center gap-xl">
              {imageBlock}
              <div className="flex flex-1 flex-col gap-2xl">
                <HeroContent showBadge={false} />
                {spinnerButtons}
              </div>
            </div>
          ) : (
            <>
              <Badge />
              <div className="flex gap-xl">
                {imageBlock}
                <HeroContent showBadge={false} />
              </div>
              {spinnerButtons}
            </>
          )
        ) : (
          <>
            <div className="flex flex-col gap-md">
              {imageBlock}
              {spinnerButtons}
            </div>
            <HeroContent />
          </>
        )}
      </Wrapper>
      {!isDesktop && (
        <div className="mt-3xl flex flex-col gap-md bg-background-default px-2xl pb-2xl sm:pb-0">
          <UnavailableHeroContent />
        </div>
      )}
      <Spinner shouldHide={!isSpinnerImmersive} />
      <DsModal
        classes={{
          body: 'flex size-full items-center justify-center',
          container: 'rounded-none size-full'
        }}
        desktopMaxHeight="100%"
        isOpen={Boolean(shouldOpenSpinnerArgs)}
        onClose={() => setShouldOpenSpinnerArgs(undefined)}
      >
        <LoadingSpinner />
      </DsModal>
    </div>
  );
}
